import { useState } from "react";

import { AdminNoticeModal } from "pages/setting/components/Sections/AdminNoticeSetting/Modals/AdminNoticeModal";
import { MenuItem } from "pages/setting/components/Sections/components/MenuItem";
import { SettingSection } from "pages/setting/components/Sections/components/SettingSection";

export const AdminNoticeSetting = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <SettingSection sectionName="공지 설정">
      <ul style={{ listStyle: "none", flexGrow: 2, margin: 0, padding: 0 }}>
        <li>
          <MenuItem
            onClick={() => setIsModalOpen(true)}
            menuName="관리자 페이지 공지 관리하기"
            style={{ cursor: "pointer" }}
          />
          <AdminNoticeModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
          />
        </li>
      </ul>
    </SettingSection>
  );
};
